import jtjs from "@/components/jtjs/index.vue";
import jlzx from "@/components/jlzx/index.vue";
import jlzxDetail from "@/components/jlzx/jlzxDetail.vue";
import gqdj from "@/components/gqdj/index.vue";
import jlpp from "@/components/jlpp/index.vue";
import djgzDetail from "@/components/gqdj/djgzDetail.vue";
import xxgk from "@/components/xxgk/index.vue";
import xxgkDetail from "@/components/xxgk/xxgkDetail.vue";
import ysgkDetail from "@/components/xxgk/ysgkDetail.vue";
import qtxxDetail from "@/components/xxgk/qtxxDetail.vue";
import gzzxDetail from "@/components/jlpp/gzzxDetail.vue";
import jlppDetail from "@/components/jlpp/jlppDetail.vue";
import rcyj from "@/components/rcyj/index.vue";
import lsddfd from "@/components/jlpp/detail/lsddfd.vue";
import lsdds from "@/components/jlpp/detail/lsdds.vue";
import yybg from "@/components/jlpp/detail/yybg.vue";
import jljk from "@/components/jlpp/detail/jljk.vue";
import tjgl from "@/components/jlpp/detail/tjgl.vue";
import lyqc from "@/components/jlpp/detail/lyqc.vue";
import lywy from "@/components/jlpp/detail/lywy.vue";
import btyy from "@/components/jlpp/detail/btyy.vue";
import knjy from "@/components/jlpp/detail/knjy.vue";
import bfycg from "@/components/jlpp/detail/bfycg.vue";
import tjyygj from "@/components/jlpp/detail/tjyygj.vue";
import gqdjDetail from "@/components/gqdj/detail.vue";
import home from "@/components/home.vue";
import bannerDetail from "@/components/bannerDetail.vue";

import innerDetail from "@/components/innerDetail.vue";
import VueRouter from "vue-router";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  routes: [
    // {
    //   path: "/",
    //   name: "index",
    //   component: home,
    //   redirect: "/",
    //   children: [
    {
      path: "/",
      name: "index",
      meta: {
        index: "1",
      },
      component: home,
    },
    {
      path: "/jtjs",
      name: "jtjs",
      meta: {
        index: "2-1",
      },
      component: jtjs,
    },
    {
      path: "/jlzx",
      name: "jlzx",
      meta: {
        index: "3",
      },
      component: jlzx,
    },
    {
      path: "/gqdj",
      name: "gqdj",
      meta: {
        index: "4-1",
      },
      component: gqdj,
    },
    {
      path: "/jlpp",
      name: "jlpp",
      meta: {
        index: "5-1-1",
      },
      component: jlpp,
    },
    {
      path: "/xxgk",
      name: "xxgk",
      meta: {
        index: "6",
      },
      component: xxgk,
    },
    {
      path: "/rcyj",
      name: "rcyj",
      meta: {
        index: "7-1",
      },
      component: rcyj,
    },
    {
      path: "/lsddfd",
      name: "lsddfd",
      meta: {
        index: "5-1-1",
      },
      component: lsddfd,
    },
    {
      path: "/tjyygj",
      name: "tjyygj",
      meta: {
        index: "5-1-2",
      },
      component: tjyygj,
    },
    {
      path: "/lsdds",
      name: "lsdds",
      meta: {
        index: "5-1-5",
      },
      component: lsdds,
    },
    {
      path: "/yybg",
      name: "yybg",
      meta: {
        index: "5-1-3",
      },
      component: yybg,
    },
    {
      path: "/jljk",
      name: "jljk",
      meta: {
        index: "5-2-2",
      },
      component: jljk,
    },
    {
      path: "/tjgl",
      name: "tjgl",
      meta: {
        index: "5-2-2",
      },
      component: tjgl,
    },
    {
      path: "/lyqc",
      name: "lyqc",
      meta: {
        index: "5-3-1",
      },
      component: lyqc,
    },
    {
      path: "/lywy",
      name: "lywy",
      component: lywy,
    },
    {
      path: "/bfycg",
      name: "bfycg",
      component: bfycg,
    },
    {
      path: "/btyy",
      name: "btyy",
      component: btyy,
    },
    {
      path: "/knjy",
      name: "knjy",
      component: knjy,
    },
    {
      path: "/bannerDetail",
      name: "bannerDetail",
      component: bannerDetail,
    },
    {
      path: "/gqdjDetail",
      name: "gqdjDetail",
      component: gqdjDetail,
    },
    {
      path: "/innerDetail",
      name: "innerDetail",
      component: innerDetail,
    },
    {
      path: "/jlzxDetail",
      name: "jlzxDetail",
      meta: {
        index: "3",
      },
      component: jlzxDetail,
    },
    {
      path: "/xxgkDetail",
      name: "xxgkDetail",
      meta: {
        index: "6",
      },
      component: xxgkDetail,
    },
    {
      path: "/ysgkDetail",
      name: "ysgkDetail",
      meta: {
        index: "6",
      },
      component: ysgkDetail,
    },
    {
      path: "/qtxxDetail",
      name: "qtxxDetail",
      meta: {
        index: "6",
      },
      component: qtxxDetail,
    },
    {
      path: "/gzzxDetail",
      name: "gzzxDetail",
      meta: {
        index: "5-2-5",
      },
      component: gzzxDetail,
    },
    {
      path: "/jlppDetail",
      name: "jlppDetail",
      meta: {
        index: "5-1-1",
      },
      component: jlppDetail,
    },
    {
      path: "/djgzDetail",
      name: "djgzDetail",
      meta: {
        index: "4-1",
      },
      component: djgzDetail,
    },
    //   ],
    // },
  ],
});
// router.afterEach((to, from) => {
//   console.log(to, from,777);
//   // 在每次路由跳转后滚动到顶部
//   console.log(window.scrollTo(),7777);
// document.getElementsByClassName("app")[0].scrollTop = 0;
//   // location.reload()
// });

router.beforeEach((to, from, next) => {
  console.log(to, 4445);
  console.log(from, 3336);
  if (from.name == "xxgkDetail" && to.name == "rcyj") {
    localStorage.setItem("gzjhPage", from.query.gzjhPage);
  } else {
    localStorage.setItem("gzjhPage", 1);
  }
  if (from.name == "xxgkDetail" && to.name == "xxgk") {
    localStorage.setItem("ssqyPage", from.query.ssqyPage);
  } else {
    localStorage.setItem("ssqyPage", 1);
  }
  if (from.name == "bannerDetail" && to.name == "xxgk") {
    localStorage.setItem("xcglPage", from.query.xcglPage);
  } else {
    localStorage.setItem("xcglPage", 1);
  }
  if (to.name == "ysgkDetail" && from.name == "xxgk") {
    localStorage.setItem("ysglPage", to.query.ysglPage);
  } else {
    localStorage.setItem("ysglPage", 1);
  }
  if (to.name == "xxgk" && from.name == "ysgkDetail") {
    localStorage.setItem("ysglPage", from.query.ysglPage);
  } else {
    localStorage.setItem("ysglPage", 1);
  }
  if (to.name == "qtxxDetail" && from.name == "xxgk") {
    localStorage.setItem("qtxxPage", to.query.qtxxPage);
  } else {
    localStorage.setItem("qtxxPage", 1);
  }
  if (to.name == "gzzxDetail" && from.name == "jlpp") {
    localStorage.setItem("gzzxPage", to.query.gzzxPage);
  } else {
    localStorage.setItem("gzzxPage", 1);
  }
  if (to.name == "jlzxDetail" && from.name == "jlzx") {
    localStorage.setItem("jlzxPage", to.query.jlzxPage);
  } else {
    localStorage.setItem("jlzxPage", 1);
  }
  if (to.name == "jlzx" && from.name == "jlzxDetail") {
    localStorage.setItem("jlzxPage", from.query.jlzxPage);
  } else {
    localStorage.setItem("jlzxPage", 1);
  }
  if (to.name == "jlppDetail" && from.name == "jlpp") {
    localStorage.setItem("jlppPage", to.query.jlppPage);
  } else {
    localStorage.setItem("jlppPage", 1);
  }
  if (to.name == "jlpp" && from.name == "jlppDetail") {
    localStorage.setItem("jlppPage", from.query.jlppPage);
  } else {
    localStorage.setItem("jlppPage", 1);
  }
  if (to.name == "djgzDetail" && from.name == "gqdj") {
    localStorage.setItem("djgzPage", to.query.djgzPage);
  } else {
    localStorage.setItem("djgzPage", 1);
  }
  if (to.name == "gqdj" && from.name == "djgzDetail") {
    localStorage.setItem("djgzPage", from.query.djgzPage);
  } else {
    localStorage.setItem("djgzPage", 1);
  }
  next();
  let x = document.getElementById("app");
  x.scrollTop = 0;
});

export default router;
